<div class="gps-denegado">
    <div class="gps-denegado__container">
        <!-- Header con botón regresar -->
        <div class="gps-denegado__header">
            <app-back-button route="/dashboard"></app-back-button>
        </div>

        <!-- Contenido principal -->
        <div class="gps-denegado__content">
            <!-- Icono de ubicación bloqueada -->
            <div class="gps-denegado__icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                    <line x1="3" y1="21" x2="21" y2="3" stroke-width="2.5"></line>
                </svg>
            </div>

            <!-- Título -->
            <h1 class="gps-denegado__title">Ubicación bloqueada</h1>

            <!-- Mensaje de error -->
            <p class="gps-denegado__message">{{ errorMessage() }}</p>

            <!-- Instrucciones -->
            <div class="gps-denegado__instructions">
                <h2 class="gps-denegado__instructions-title">Para habilitar la ubicación:</h2>

                <div class="gps-denegado__instruction-list">
                    <div class="gps-denegado__instruction-item">
                        <span class="gps-denegado__instruction-number">1</span>
                        <div class="gps-denegado__instruction-content">
                            <strong>En Chrome/Edge:</strong>
                            <p>Haga clic en el ícono de candado en la barra de direcciones → Permitir ubicación</p>
                        </div>
                    </div>

                    <div class="gps-denegado__instruction-item">
                        <span class="gps-denegado__instruction-number">2</span>
                        <div class="gps-denegado__instruction-content">
                            <strong>En Firefox:</strong>
                            <p>Haga clic en el ícono de ubicación en la barra de direcciones → Permitir</p>
                        </div>
                    </div>

                    <div class="gps-denegado__instruction-item">
                        <span class="gps-denegado__instruction-number">3</span>
                        <div class="gps-denegado__instruction-content">
                            <strong>En Safari (iOS):</strong>
                            <p>Ajustes → Safari → Ubicación → Permitir</p>
                        </div>
                    </div>

                    <div class="gps-denegado__instruction-item">
                        <span class="gps-denegado__instruction-number">4</span>
                        <div class="gps-denegado__instruction-content">
                            <strong>En Android:</strong>
                            <p>Ajustes → Aplicaciones → Claro → Permisos → Ubicación → Permitir</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Botones de acción -->
            <div class="gps-denegado__actions">
                <button type="button" class="gps-denegado__btn gps-denegado__btn--primary" (click)="handleRetry()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5">
                        <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"></path>
                        <path d="M21 3v5h-5"></path>
                    </svg>
                    Reintentar
                </button>

                <button type="button" class="gps-denegado__btn gps-denegado__btn--secondary" (click)="handleGoBack()">
                    Ir al inicio
                </button>
            </div>
        </div>
    </div>
</div>